/*
 * Copyright (c) 2022 E-WIND - Thais Watanabe.
 * All rights reserved.
 */
import React from "react";

/**
 * The Table component
 *
 * @author Thais Watanabe
 */
const Table = (props) => {
  return (
    <div className="md:overflow-visible overflow-x-auto print:overflow-auto">
      <table id={props.id} className={`${props.className} min-w-full`}>
        {props.children}
      </table>
    </div>
  );
};

/**
 * ColHeader
 * @param {*} props
 */
const ColHeader = (props) => {
  return (
    <th
      id={props.id}
      colSpan={props.colSpan}
      rowSpan={props.rowSpan}
      scope="col"
      className={`${props.className} p-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-gray-200 print:text-xxs print:p-0.5 print:text-black print:border-black`}
    >
      {props.children}
    </th>
  );
};

/**
 * Col
 * @param {*} props
 */
const Col = (props) => {
  return (
    <td
      id={props.id}
      colSpan={props.colSpan}
      rowSpan={props.rowSpan}
      className={`${props.className} p-3 text-sm text-gray-500 border border-gray-200 print:text-xxs print:p-0.5 print:text-black print:border-black`}
    >
      {props.children}
    </td>
  );
};

/**
 * TableBody
 * @param {*} props
 */
const TableBody = (props) => {
  return <tbody>{props.children}</tbody>;
};

export { Table, ColHeader, TableBody, Col };
